import { NgIf } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  AnalyticsService,
  KpiProperty,
  KpiPropertySale,
  KpiPropertyShare,
  KpiUser,
} from "@eemo/api-client";
import { KpiCompany } from "@eemo/api-client/model/kpiCompany";
import { KpiSubscription } from "@eemo/api-client/model/kpiSubscription";
import { KpiComponent } from "../kpi/kpi.component";

@Component({
  selector: "app-analytics",
  templateUrl: "./analytics.component.html",
  styleUrls: ["./analytics.component.scss"],
  standalone: true,
  imports: [NgIf, KpiComponent],
})
export class AnalyticsComponent implements OnInit {
  kpiUser: KpiUser;
  kpiProperty: KpiProperty;
  kpiPropertySale: KpiPropertySale;
  kpiPropertyShare: KpiPropertyShare;
  kpiCompany: KpiCompany;
  kpiSubscription: KpiSubscription;

  cardClass = "col-12 col-sm-6 col-md-4 col-xl-3 mb-3";

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    this.analyticsService
      .getKpiUsers()
      .subscribe((kpi) => (this.kpiUser = kpi));
    this.analyticsService
      .getKpiProperties()
      .subscribe((kpi) => (this.kpiProperty = kpi));
    this.analyticsService
      .getKpiPropertySales()
      .subscribe((kpi) => (this.kpiPropertySale = kpi));
    this.analyticsService
      .getKpiPropertyShares()
      .subscribe((kpi) => (this.kpiPropertyShare = kpi));
    this.analyticsService
      .getKpiCompanies()
      .subscribe((kpi) => (this.kpiCompany = kpi));
    this.analyticsService
      .getKpiSubscriptions()
      .subscribe((kpi) => (this.kpiSubscription = kpi));
  }
}
